export const pusherEndpointURL = 'v1/pusher/authorize-channel';
export const pusherNotificationEvent = 'new-package-request';
export const pusherNotificationChannel = 'private-new-package-request';
